var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClaimSymbolSocial = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2563_224408)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2563_224408",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 60,
    rx: 6,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2563_224408)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 53,
    r: 49,
    fill: "#FFB801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4057 41.0322C18.4057 41.0322 15.7483 41.0322 15.7483 38.391C15.7483 35.7498 18.4057 27.8262 31.6926 27.8262C44.9795 27.8262 47.6369 35.7498 47.6369 38.391C47.6369 41.0322 44.9795 41.0322 44.9795 41.0322H18.4057ZM31.6926 25.185C33.8069 25.185 35.8347 24.3502 37.3298 22.8643C38.8248 21.3783 39.6647 19.3629 39.6647 17.2615C39.6647 15.16 38.8248 13.1446 37.3298 11.6587C35.8347 10.1727 33.8069 9.33789 31.6926 9.33789C29.5782 9.33789 27.5505 10.1727 26.0554 11.6587C24.5604 13.1446 23.7204 15.16 23.7204 17.2615C23.7204 19.3629 24.5604 21.3783 26.0554 22.8643C27.5505 24.3502 29.5782 25.185 31.6926 25.185Z",
    fill: "#FFE8AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3472 28.6585C46.4061 30.385 48.0993 32.6952 48.9672 34.694H60.7466C60.7466 34.694 62.5182 34.694 62.5182 32.9332C62.5182 31.1724 60.7466 25.89 51.8887 25.89C47.5489 25.89 44.91 27.158 43.3472 28.6585ZM55.6468 22.582C54.6501 23.5727 53.2983 24.1292 51.8887 24.1292C50.4791 24.1292 49.1273 23.5727 48.1306 22.582C47.1339 21.5914 46.5739 20.2478 46.5739 18.8468C46.5739 17.4459 47.1339 16.1023 48.1306 15.1116C49.1273 14.121 50.4791 13.5645 51.8887 13.5645C53.2983 13.5645 54.6501 14.121 55.6468 15.1116C56.6435 16.1023 57.2035 17.4459 57.2035 18.8468C57.2035 20.2478 56.6435 21.5914 55.6468 22.582Z",
    fill: "#FFE8AC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2563_224408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 60,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClaimSymbolSocial);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/claim-symbol-social.b54d3bf958de0da3358d2771b4f1b79e.svg";